var map = {
	"./canari.png": 1928,
	"./canari_beach.png": 1929,
	"./canari_birthday.png": 1930,
	"./canari_covid.png": 1931,
	"./canari_egg.png": 1932,
	"./canari_fireworks.png": 1933,
	"./canari_halloween.png": 1934,
	"./canari_logo.png": 1935,
	"./canari_logo_beach.png": 1936,
	"./canari_logo_birthday.png": 1937,
	"./canari_logo_covid.png": 1938,
	"./canari_logo_egg.png": 1939,
	"./canari_logo_fireworks.png": 1940,
	"./canari_logo_halloween.png": 1941,
	"./canari_logo_love.png": 1942,
	"./canari_logo_music.png": 1943,
	"./canari_logo_noel.png": 1944,
	"./canari_logo_patrick.png": 1945,
	"./canari_logo_ski.png": 1946,
	"./canari_logo_work.png": 1947,
	"./canari_love.png": 1948,
	"./canari_music.png": 1949,
	"./canari_noel.png": 1950,
	"./canari_patrick.png": 1951,
	"./canari_ski.png": 1952,
	"./canari_work.png": 1953,
	"./icon-laposte.svg": 1954,
	"./icon-status.png": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1927;